'use strict';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const DEFAULT_SLIDES_INTERVAL = 10;
/**
 * Single source of truth
 */
const state = {
  slidesIntervalInSeconds: DEFAULT_SLIDES_INTERVAL,
  fontSize: 1,
  cards: [],
  theme: {},
  allWallboardStatistics: [],
  name: 'WALLBOARD'
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
